import { useSnackbar } from 'notistack';

import { axios } from 'lib';
import { useMutation } from 'react-query';

const removeRemoveFile = async ({ faId, facId = null, cgId = null, fileId }) => {
  let url = `/api/framework_agreements/${faId}/files/${fileId}`;
  if (facId) {
    url = `/api/framework_agreements/${faId}/suppliers/${facId}/files/${fileId}`;
  }

  if (cgId) {
    url = `/api/framework_agreements/${faId}/consortium_groups/${cgId}/files/${fileId}`;
  }

  axios.delete(url);
}
  

export const useRemoveFile = (onFileRemoval) => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: removeRemoveFile,
    onSuccess: () => {
      enqueueSnackbar('The file was succesfully deleted', {
        variant: 'success',
        anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
      });

      onFileRemoval();
    },
    onError: (error) => {
      enqueueSnackbar(error?.message || 'Some error occured', { variant: 'error' });
    },
  });
};
